import React from "react";

/**
 * Renders a multi-sentence headline with one sentence per line.
 * Balancing mid-sentence reads badly on display type — a sentence should end
 * where the line ends unless it's too long to fit on its own. A colon counts
 * as a break too, so "…Torah: / Play it." lands the way it's spoken.
 */
export default function SentenceLines({ text }) {
  const sentences = text.match(/[^.!?:]+[.!?:]*/g) || [text];
  return sentences
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s, i, arr) => (
      <React.Fragment key={s}>
        {s}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ));
}
